import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import api from 'api'

const _baseURL = process.env.REACT_APP_BASE_URL

export const deviceRtkApi = createApi({
  reducerPath: 'deviceRtkApi',
  refetchOnMountOrArgChange: 60,
  tagTypes: ['MappingList'],
  baseQuery: fetchBaseQuery({
    baseUrl: `${_baseURL}/admin`,
    prepareHeaders: async (headers) => {
      const token = await api.checkToken()
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  endpoints: (builder) => ({
    getDevices: builder.query({
      query: () => '/devices',
      transformResponse: (responce) => {
        return responce?.body?.devices || []
      },
    }),
    getMappingList: builder.query({
      query: (id) => `/devices/mapping/list/${id}`,
      providesTags: ['MappingList'],
      transformResponse: (responce) => {
        return responce?.body || []
      },
    }),
    createMappingDeviceToMeter: builder.mutation({
      query: (body) => ({
        url: '/devices/mapping',
        method: 'POST',
        body,
      }),
      invalidatesTags: (res) => (res ? ['MappingList'] : null),
    }),
    updateMappingDeviceToMeter: builder.mutation({
      query: ({ deviceToChannnelMappingId, ...body }) => ({
        url: `/devices/mapping/${deviceToChannnelMappingId}`,
        method: 'PATCH',
        body,
        // headers: {
        //   'content-type': 'application/json',
        // },
      }),

      invalidatesTags: (res) => (res ? ['MappingList'] : null),
    }),
    deleteMappingDeviceToMeter: builder.mutation({
      query: (deviceToChannnelMappingId) => ({
        url: `/devices/mapping/${deviceToChannnelMappingId}`,
        method: 'DELETE',
        headers: {
          'content-type': 'application/json',
        },
      }),

      invalidatesTags: (res) => (res ? ['MappingList'] : null),
    }),
  }),
})

export const {
  useGetDevicesQuery,
  useGetMappingListQuery,
  useCreateMappingDeviceToMeterMutation,
  useUpdateMappingDeviceToMeterMutation,
  useDeleteMappingDeviceToMeterMutation,
  useLazyGetMappingListQuery,
} = deviceRtkApi
